'use strict';

var styleInject_es = require('../../../../node_modules/style-inject/dist/style-inject.es.js');

var css_248z = "@media (min-width: 768px) {\n  .varta-search-vehicle-type__row {\n    display: flex;\n    flex-direction: row;\n    flex-wrap: wrap;\n    margin-left: -10px;\n    margin-right: -10px; } }\n\n@media (min-width: 768px) {\n  .varta-search-vehicle-type__col {\n    flex: 0 0 50%;\n    max-width: 50%;\n    box-sizing: border-box;\n    padding-right: 10px;\n    padding-left: 10px; } }\n";
styleInject_es(css_248z);
